<template>
  <div class="category-lists">
    <div
      v-for="(categoryList, brandName) in groupedCategories"
      :key="brandName"
      class="category-list p-8"
    >
      <h3
        v-if="brandName"
      >
        <span
          class="h5"
        >{{ $tv(brandName, 'brands') }}</span>
        <InfoIcon
          popup-ref="showBrandsPopup"
        />
      </h3>
      <div
        class="category-list__tiles"
      >
        <CategoryTile
          v-for="(category) in categoryList"
          :key="parentId + '_' + brandName + '_' + category.id"
          :category="category"
          :path="path"
          :lazy="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {defaultCategoriesComparer} from '~/assets/js/utils/category_comparer'
import CategoryTile from '~/components/category/CategoryTile'
import InfoIcon from '~/components/InfoIcon.vue'

let i = 0
export default {
  components: {
    CategoryTile,
    InfoIcon
  },
  props: {
    categories: {
      type: Array || null,
      default () {
        return []
      }
    },
    path: {
      type: String,
      default () {
        return null
      }
    },
    parentId: {
      type: Number,
      default() {
        return i++
      }
    },
    lazy: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    groupedCategories: function () {
      // Group by brands (if at least one one product design exists in subcategories)
      if (Array.isArray(this.categories) && this.categories.find(c => c?.IsProductDesign)) {
        return this.groupByBrands(this.categories)
      }
      // Without grouping (if no product design exists in subcategories)
      else if (Array.isArray(this.categories)) {
        return {'': [...this.categories].sort(defaultCategoriesComparer)}
      }
      return []
    }
  },
  methods: {
    groupByBrands: function (array) {
      let allBrands = new Set()
      const groupByCode = array.reduce(function (aggregate, val) {
        val.brands.forEach(brand => {
          aggregate[brand.Code] = aggregate[brand.Code] || []
          allBrands.add(brand.Code)
          aggregate[brand.Code].push(val)
        })

        return aggregate
      }, {})

      for (const brand of allBrands) {
        groupByCode[brand].sort(defaultCategoriesComparer)
      }

      // move Freudenberg to front
      const freudenbergKey = 'F'
      let orderedGroup = {}
      if (Object.prototype.hasOwnProperty.call(groupByCode, freudenbergKey)) {
        const freudenberg = {...groupByCode[freudenbergKey]}
        if (freudenberg) {
          delete groupByCode[freudenbergKey]
          orderedGroup = {...orderedGroup, ...{[freudenbergKey]: freudenberg}}
        }
      }

      orderedGroup = {...orderedGroup, ...groupByCode}
      return orderedGroup
    }
  }
}
</script>
<style lang="scss">
.category-list {
  background-color: $color__content--background__secondary;
  display: flex;
  flex-flow: column wrap;

  + .category-list {
    padding-top: 0;
  }

  h3 {
    &:first-child {
      margin-top: 0;
    }
  }

  &__tiles {
    $gap: 1.25rem;

    display: inline-flex;
    flex-wrap: wrap;
    margin: -#{$gap} 0 0 -#{$gap};
    width: calc(100% + #{$gap});

    > .category-tile {
      margin: #{$gap} 0 0 #{$gap};
    }

    @include breakpoint-down($md) {
      $gap: .563rem;

      margin: -#{$gap} 0 0 -#{$gap};
      width: calc(100% + #{$gap});

      > .category-tile {
        margin: #{$gap} 0 0 #{$gap};
      }
    }
  }
}
</style>
